import '@firebase/auth';